// extracted by mini-css-extract-plugin
export default {"toggle":"ADKWNR","toggleActive":"u6zZ7R","dotted":"TJWlaz"};